<template id="map-template">
  <div class="map-root select-none">
    <div ref="map-emap" class="map"></div>
    <div class="global-loading">
      <table>
        <tr>
          <td>
            <span class="global-loading-text" v-html="loadingText"></span>
          </td>
        </tr>
      </table>
    </div>
    <div class="map-header">
      <div class="map-header-wrapper select-none">
        <div class="title">
          <div class="text">{{basicData.eventName}}应急指挥中</div>
          <div class="time">事发时间：{{basicData.happenTime}}</div>
          <div class="time">当前时间：{{currentTime}}</div>
        </div>
        <div class="btns">
          <div class="btn-position select-none" @click="goHome">
            <!-- <img
              src="../../../theme-default/src/images/emergencyoperations-header-button-home.png"
            /> -->
            首页
          </div>
          <div class="btn-position select-none" @click="goCenter">
            <img
              src="../../../theme-default/src/images/emergencyoperations-header-button-position.png"
            />
            事故位置
          </div>
          <div class="btn-close select-none" @click="closeemergency">
            <img
              src="../../../theme-default/src/images/emergencyoperations-header-button-close.png"
            />
            结束应急
          </div>
        </div>
        <div class="spend-time">
          <span>{{dateduration.hh}}</span>
          <span>{{dateduration.hl}}</span>
          <span>:</span>
          <span>{{dateduration.mh}}</span>
          <span>{{dateduration.ml}}</span>
          <span>:</span>
          <span>{{dateduration.sh}}</span>
          <span>{{dateduration.sl}}</span>
        </div>
      </div>
    </div>
    <div class="map-left">
      <div>
        <ComponentLeftPanel
          v-bind:ExecutId="this.query.ExecutId"
          :roomId="roomId"
          :pwd="pwd"
          :center="center"
          @searchPoi="search"
        ></ComponentLeftPanel>
      </div>
    </div>
    <div class="map-right">
      <div>
        <ComponentRightPanel
          v-bind:ExecutId="this.query.ExecutId"
          v-bind:tableData="executeTaskList"
          v-bind:planName="planData.planName"
          v-bind:planId="planData.id"
          v-bind:optionsObj="optionsObj"
          :roomId="roomId"
          :pwd="pwd"
        ></ComponentRightPanel>
      </div>
    </div>
    <!-- <div class="map-location" @click="handleSwitch2D3D">2D/3D切换</div> -->
    <el-dialog
      class="select-none scroll-no"
      custom-class="emergencyoperations-dialog"
      title="应急预案启动中1"
      top="17vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isVisiable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <ComponentTaskList v-bind:tableData="executeTaskList" v-bind:planName="planData.planName"  v-bind:optionsObj="optionsObj"/>
    </el-dialog>

    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMaterialStorageVisiable"
      :modal="true"
    >
      <MaterialWarehouseinfo v-bind:query="materialQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isRescueTeamVisiable"
      :modal="true"
    >
      <ResourcesTeaminfo v-bind:query="rescueTeamQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isTranresourcesmanageVisiable"
      :modal="true"
    >
      <Tranresourcesinfo v-bind:query="tranresourcesQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isSheltermanageVisiable"
      :modal="true"
    >
      <Shelterinfo v-bind:query="sheltermanageQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isCommunicationresourcesVisiable"
      :modal="true"
    >
      <Communicationresourcesinfo v-bind:query="communicationresourcesQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMedicalResourcesVisiable"
      :modal="true"
    >
      <Medicalresourcesinfo v-bind:query="medicalResourcesQuery" />
    </el-dialog>

    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMateriallistVisiable"
      :modal="true"
    >
      <Materiallist v-bind:query="materiallistQuery" :WarehouseId="materiallistQuery.id"/>
    </el-dialog>
  </div>
</template>

<script>
import ZJApp from '../../../../../app';
const utils = ZJApp.ZJUtils;
import { getDictionary } from "@/api/src/emergency_common";
import { detail } from "@/api/src/emergency_event";
import { list } from "@/api/src/emergency_command_task"; 
import { detail as planLisDetail } from "@/api/src/emergency_plan";

import ComponentLeftPanel from "./Components/Component-LeftPanel";
import ComponentRightPanel from "./Components/Component-RightPanel";
import ComponentTaskList from "./Components/Component-StartTaskList";

import MaterialWarehouseinfo from "../Material/MaterialWarehouseinfo";
import ResourcesTeaminfo from "../Resources/ResourcesTeaminfo";
import Tranresourcesinfo from "../Resources/Tranresourcesinfo";
import Shelterinfo from "../Resources/Shelterinfo";
import Communicationresourcesinfo from "../Resources/Communicationresourcesinfo";
import Medicalresourcesinfo from "../Resources/Medicalresourcesinfo";

import Materiallist from "../Material/Materiallist";

import dayjs from 'dayjs'

export default {
  name: "ZjEmergencyOperations",
  componentName: "ZjEmergencyOperations",
  components: {
    ComponentLeftPanel: ComponentLeftPanel,
    ComponentRightPanel: ComponentRightPanel,
    ComponentTaskList: ComponentTaskList,

    MaterialWarehouseinfo: MaterialWarehouseinfo,
    ResourcesTeaminfo: ResourcesTeaminfo,
    Tranresourcesinfo: Tranresourcesinfo,
    Shelterinfo: Shelterinfo,
    Communicationresourcesinfo: Communicationresourcesinfo,
    Medicalresourcesinfo: Medicalresourcesinfo,
    Materiallist: Materiallist,
  },
  props: {
    query: {
      ExecutId: {
        type: String,
        required: true,
        default: "",
      },
    },
    toUrl: {
      type: String,
      default: "/plugin/Emergency/UI/FinishEvent",
    },
  },
  data() {
    return {
      roomId: ZJApp.ZJUtils.uuid(),
      pwd: "123456",
      msgkey: {
        emergencyFinishTaskKey:"MessageKey_EmergencyFinishTask" + this.query.ExecutId,
        startTaskMsgKey: "MessageKey_EmergencyEventStartTask",
      },
      center: {
        type: Object,
        default: function () {
          return [0, 0];
        },
      },
      loadingText: "加载中...",
      mapInstance: null,
      basicData: {
        happenTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      },
      currentTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      isVisiable: false,
      //执行任务列表
      executeTaskList: [],
      planData: "",
      isMaterialStorageVisiable: false,
      materialQuery: {
        type: "search",
        id: "",
        category: "",
      },
      isRescueTeamVisiable: false,
      rescueTeamQuery: {
        type: "search",
        id: "",
        category: "",
      },
      isTranresourcesmanageVisiable: false,
      tranresourcesQuery: {
        type: "search",
        id: "",
        category: "",
      },
      isSheltermanageVisiable: false,
      sheltermanageQuery: {
        type: "search",
        id: "",
        category: "",
      },
      isCommunicationresourcesVisiable: false,
      communicationresourcesQuery: {
        type: "search",
        id: "",
        category: "",
      },
      isMedicalResourcesVisiable: false,
      medicalResourcesQuery: {
        type: "search",
        id: "",
        category: "",
      },

      isMateriallistVisiable: false,
      materiallistQuery: {
        type: "search",
        id: "",
        category: "",
      },
      options:[],
      optionsObj:{}
    };
  },
  methods: {
    goHome(){
      this.$router.push({
        path: '/plugin/Emergency/UI/OneMap',
      });
    },
    basedatabind(){
      const loading = this.startloading();
      return utils.waitAll([
        getDictionary('emergency_command_status'),
      ])
      .then(r => {
        //擅长事故类型
        this.options = r[0].data.records;
        let obj = {}
        this.options.map(item =>{
          obj[item.code] = item.value
        })
        this.optionsObj = obj

        loading.close();

        return r;
      })
      .catch(e => {
        console.error(e);
        loading.close();
      });
    },
    goCenter: function () {
      // eslint-disable-next-line no-undef
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
    },
    //添加应急点
    addDom: function () {
      if (!this.mapInstance) return;
      // eslint-disable-next-line no-undef
      var $div = $("<div></div>");
      $div.append(this.getSvgContent());
      $div.css({
        width: "30rem",
        height: "30rem",
        "margin-left": "-15rem",
        "margin-top": "-15rem",
        position: "absolute",
      });

      var interval = setInterval(() => {
        if (this.mapInstance) {
          let layer = this.mapInstance.getLayerByName("DOM");
          if (layer && layer.addDom) {
            clearInterval(interval);
            layer.addDom(this.center[0], this.center[1], $div[0]);
          }
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    // 获取应急点html
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    loadExecuteTask: function () {
      return list({ eventId: this.query.ExecutId,taskType:1,current:1,size:10000 })
        .then((r) => {
          r = r.data.records;
          this.executeTaskList = r;
        })
        .catch((e) => {
        });
    },
    //资源点查询方法，过滤地图点位
    search: function (text) {
      var map = this.mapInstance;
      var layers = map.getLayers();

      if (text) {
        // eslint-disable-next-line no-undef
        $(layers).each(function () {
          if (this.$className === "OverlayLayer") {
            this.filter(function (d) {
              var label = this.getLabel(d) || "";
              return label.indexOf(text) >= 0;
            });
          }
        });
      } else {
        // eslint-disable-next-line no-undef
        $(layers).each(function () {
          if (this.$className === "OverlayLayer") {
            this.clearFilter();
          }
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    onSearchResultPoiSelected: function (id) {
      console.log("onSearchResultPoiSelected:" + id);
      var overlay,
        layers = this.mapInstance.getLayers();

      for (let index = 0; index < layers.length; index++) {
        var ly = layers[index];
        if (ly.findOverlayById) {
          overlay = ly.findOverlayById(id);
          if (overlay && overlay.length > 0) {
            ly.onClick.apply(overlay[0], [{}]);
            break;
          }
        }
      }
    },
    showRecordDetail(params) {
      switch (params.category) {
        case "MaterialStorage":
          this.isMaterialStorageVisiable = true;
          this.materialQuery.id = params.id;
          break;
        case "RescueTeam":
          this.isRescueTeamVisiable = true;
          this.rescueTeamQuery.id = params.id;
          break;
        case "Tranresourcesmanage":
          this.isTranresourcesmanageVisiable = true;
          this.tranresourcesQuery.id = params.id;
          break;
        case "Sheltermanage":
          this.isSheltermanageVisiable = true;
          this.sheltermanageQuery.id = params.id;
          break;
        case "Communicationresources":
          this.isCommunicationresourcesVisiable = true;
          this.communicationresourcesQuery.id = params.id;
          break;
        case "MedicalResources":
          this.isMedicalResourcesVisiable = true;
          this.medicalResourcesQuery.id = params.id;
          break;
        default:
          console.error("未处理的物资类别 :" + params.category);
          break;
      }
    },
    showinventoryList(params) {
      this.isMateriallistVisiable = true;
      this.materiallistQuery.warehouseId = params.id;
    },
    //结束应急
    closeemergency() {
      let that = this;

      this.$confirm("即将结束应急, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$router.push({
          path: that.toUrl,
          query: {
            id: this.basicData.id,
            Status: "5",
          },
        });
        that.theme.header.visiable = true;
        that.theme.sidemenu.visiable = true;
        // eslint-disable-next-line no-undef
        $(".zj-app").removeClass("zj-emergencyoperations-map");
      });
    },
    startloading() {
      const loading = this.$loading({
        //tatget: document.querySelector("#zj-component-starttasklist"),
        lock: true,
        fullscreen: false,
        text: "",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.5)",
        customClass: "custom-loading-mask",
      });
      return loading;
    },
    drawMap: function () {
      let that = this;
      // 创建地图，并通过样式让地图填满窗口

      this.$nextTick(function () {
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。

          // eslint-disable-next-line no-undef
          $(that.$refs["map-emap"]).zjumap({
            syscode: "ZJMap",
            key: "EmergencyOneMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            mapConfigs: {
              //mapStyle: "styles/darknight.json",
              toggleTool: "tool/TreeToggleX",
              //tilesPath: "",
              //clickToShowLocation: false,
              navigationControl3D:true,
              onMapCreated: function (e) {
                that.mapInstance = e.map;
                // that.center = e.map.config.center;
                //that.goCenter();
              },
              // eslint-disable-next-line no-unused-vars
              onLayerRendered: function (e) {},
              // eslint-disable-next-line no-unused-vars
              onGettingLayerData: function (e) {
                // console.log({
                //   funName: "onGettingLayerData",
                //   data: that.center,
                // });
                // eslint-disable-next-line no-undef
                e.opts.ServiceData = $.extend({}, e.opts.ServiceData, {
                  Longitude: that.center[0],
                  Latitude: that.center[1],
                });
              },
              //地图开关面板切换事件，切换右侧列表框的tab项
              onToogleSwitchClick: function (e) {
                that.broadcast(
                  "componentPOISearchResult",
                  "onMapToogleSwitchClick",
                  e.type
                );
              },
              onLayerDetaiButtonClick: function (e) {
                console.log(e);
                var item = e.originEvent.currentTarget;
                // eslint-disable-next-line no-undef
                var id = e.data.id;
                // eslint-disable-next-line no-undef
                var category = $(item).data("category");
                var result = {
                  id: id,
                  type: "search",
                  category: category,
                };
                that.showRecordDetail(result);
              },
            },
            //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
          });
        });
      });
    },
    loadEventInfo() {
      if (!this.query.ExecutId) {
        this.$message({
            type: "info",
            message: "执行记录Id【ExecutId】不能为空"
          });
        return false;
      }

      let that = this;

      const loading = this.startloading();
      //获取执行记录信息
      detail( this.query.ExecutId )
        .then((r) => {
          r = r.data;
          console.log(r)
          // 获取执行记录信息，加载预案名称、触发任务启动弹窗
          that.planName = r.eventName;
          that.isVisiable = true;

          //设置事件中心点,事发事件
          that.center = [r.longitude, r.latitude];
          // try {
          //   that.basicData.happenTime = r.happenTime;
          // } catch (e) {
          //   that.basicData.happenTime = currentTime;
          // }
          that.basicData = r
          // 创建定时器
          that.timer = setInterval(function () {
            that.currentTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
          }, 1000);
          
          planLisDetail(r.planId).then(d =>{
            d = d.data
            that.planData = d
          })
          loading.close();
        })
        .catch((e) => {
          loading.close();
        });
    },
    // eslint-disable-next-line no-unused-vars
    onEmergencyFinishTaskKey: function (msg) {
      var record = JSON.parse(msg.firstBlock().text);

      if (
        this.executeTaskList.some(function (item) {
          return item.ExecutTaskId == record.ExecutTaskId;
        })
      ) {
        var result = [];
        // eslint-disable-next-line no-undef
        $.each(this.executeTaskList, function () {
          var item = this;
          if (item.ExecutTaskId == record.ExecutTaskId) {
            // eslint-disable-next-line no-undef
            item = $.extend({}, item, record);
          }
          result.push(item);
        });

        this.executeTaskList = result;
      } else {
        this.executeTaskList.unshift(record);
      }
    },
    onJoinRoomRequestReceived: function (args) {
      //广播消息给子组件
      this.broadcast(
        "ZJEmergencyRealtimecall",
        "onJoinRoomRequestReceived",
        args
      );
    },
    handleSwitch2D3D: function () {
      console.log("handleSwitch2D3D");
      if (this.mapInstance.map.getTilt() == 0) {
        this.mapInstance.map.setTilt(60);
      } else {
        this.mapInstance.map.setTilt(0);
      }
    },
  },
  //初始化，隐藏菜单
  created() {
    this.theme.header.visiable = false;
    this.theme.sidemenu.visiable = false;
    // 组件创建时，设置本页样式
    // eslint-disable-next-line no-undef
    $(".zj-app").addClass("zj-emergencyoperations-map");
    this.$notify.subscript(this.msgkey.emergencyFinishTaskKey, (x) =>
      // this.onEmergencyFinishTaskKey(x)
      this.loadExecuteTask()
    ); 
    this.$notify.subscript(this.msgkey.startTaskMsgKey, (x) =>
      this.loadExecuteTask()
    );

    this.$on("showRecordDetail", this.showRecordDetail);
    this.$on("showinventoryList", this.showinventoryList);
    this.$on("poiselected", this.onSearchResultPoiSelected);
    this.$on("onJoinRoomRequestReceived", this.onJoinRoomRequestReceived);
  },
  mounted() {
    //加载事件信息
    this.loadEventInfo();
    //绘制地图
    this.drawMap();
    this.basedatabind().then(()=>{
      //加载执行任务
      this.loadExecuteTask();
    });
  },
  computed: {
    dateduration: function () {
      var new_date = new Date(this.currentTime); 
      var old_date = new Date(this.basicData.happenTime);

      var difftime = (new_date - old_date)/1000; //计算时间差,并把毫秒转换成秒
      var days = parseInt(difftime/86400); // 天  24*60*60*1000 
      var hours = parseInt(difftime/3600);    // 小时 60*60 总小时数-过去的小时数=现在的小时数 
      var minutes = parseInt(difftime%3600/60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
      var seconds = parseInt(difftime%60);  // 以60秒为一整份 取余 剩下秒数

      return {
        hours: hours,
        hh: parseInt(hours / 10) % 10,
        hl: hours % 10,
        minutes: minutes,
        mh: parseInt(minutes / 10),
        ml: minutes % 10,
        seconds: seconds,
        sh: parseInt(seconds / 10),
        sl: seconds % 10,
      };
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
    }
  },
  destroyed() {
    this.$notify.unsubscript(this.msgkey.emergencyFinishTaskKey);
    this.$notify.unsubscript(this.msgkey.startTaskMsgKey);
    // 销毁组件时，还原样式
    // eslint-disable-next-line no-undef
    this.theme.header.visiable = true;
    this.theme.sidemenu.visiable = true;
    $(".zj-app").removeClass("zj-emergencyoperations-map");
  },
  watch: {
    //监听中心点，绘制应急中心点
    center: function () {
      let that = this;
      var interval = setInterval(() => {
        if (that.mapInstance) {
          clearInterval(interval);
          this.addDom();
        }
      }, 1000);
    },
  },
  template: "#map-template",
  controller: "UI",
  action: "EmergencyOperations",
};
</script>